var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.69.01a5.95 5.95 0 00-4.19 1.71l-.2.2-.2-.2A5.88 5.88 0 003.64.45a5.88 5.88 0 00-1.92 9.57l.2.2 5.33 5.3 1.23 1.22.02.02.53.53a1.77 1.77 0 001.93.38c.21-.09.41-.22.57-.38l.5-.49 1.29-1.28 5.31-5.29.2-.2a5.88 5.88 0 001.3-6.4A5.97 5.97 0 0014.68 0v.01z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--heart-filled-30abd70afb378bdf63fcecc4aa9388e0.svg";
export { SvgIconUiHeartFilled as Component };